import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservablePerformanceConfigRequest, RpcObservablePerformanceError, RpcObservablePerformanceKey, RpcObservablePerformanceResult
} from './rpc-observable-performance-model';

export class RpcObservablePerformanceConfigServer
    extends RpcObservableServer<RpcObservablePerformanceConfigRequest, RpcObservablePerformanceResult, RpcObservablePerformanceError> {

    /**
     * Initializes a new instance of the RpcObservablePerformanceConfigServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservablePerformanceKey.configCommand, RpcObservablePerformanceKey.version);
    }
}
